/**
 * Default column width constants for list views
 *
 * These widths are used for primary columns (Name, URL, etc.) across different entity types.
 * The sizes are chosen based on typical content length to minimize truncation while
 * keeping tables compact.
 */
export const DEFAULT_PRIMARY_COLUMN_WIDTHS = {
  /** 200px - For short identifiers (e.g., Custom Channels) */
  SMALL: 200,

  /** 250px - Standard entity names (Accounts, Opportunities, Persons, Salespeople, AI Fields) */
  MEDIUM: 250,

  /** 300px - Longer names (Channels) */
  LARGE: 300,

  /** 400px - Very long content like URLs and detailed campaign names */
  XLARGE: 400,
} as const;

/**
 * Default width for non-primary columns
 */
export const DEFAULT_COLUMN_WIDTH = 150;
